var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 5.0745 0 2.81177 1.40589 1.40589C2.81177 0 5.0745 0 9.6 0H10.4C14.9255 0 17.1882 0 18.5941 1.40589C20 2.81177 20 5.0745 20 9.6V10.4C20 14.9255 20 17.1882 18.5941 18.5941C17.1882 20 14.9255 20 10.4 20H9.6C5.0745 20 2.81177 20 1.40589 18.5941C0 17.1882 0 14.9255 0 10.4V9.6Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6073 14.4C5.96073 14.4 3.31043 11.2468 3.2 6H5.52755C5.604 9.85105 7.31988 11.4823 8.67903 11.8186V6H10.8707V9.32132C12.2129 9.17838 13.6229 7.66486 14.0986 6H16.2902C15.925 8.05165 14.3959 9.56517 13.3086 10.1874C14.3959 10.6919 16.1374 12.012 16.8 14.4H14.3874C13.8692 12.8024 12.5782 11.5664 10.8707 11.3982V14.4H10.6073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_3457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/VK.2a86ee27bf962c7a126e78b213b05912.svg";
export { ForwardRef as ReactComponent };